/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto } from './FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto';
import {
    instanceOfFxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto,
    FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoFromJSON,
    FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoFromJSONTyped,
    FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoToJSON,
} from './FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto';

/**
 * @type FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersion
 * 
 * @export
 */
export type FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersion = FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto;

export function FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionFromJSON(json: any): FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersion {
    return FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersion {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto(json)) {
        return FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionToJSON(json: any): any {
    return FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionToJSONTyped(json, false);
}

export function FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionToJSONTyped(value?: FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto(value)) {
        return FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoToJSON(value as FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto);
    }

    return {};
}

